document.querySelectorAll('[data-lfh-carousel]').forEach(carousel => {
  const slides = [...carousel.querySelectorAll('[data-lfh-slide]')];
  const pause = carousel.querySelector('[data-lfh-pause]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let index = 0;
  let stopped = reduced.matches;
  let timer;
  function show(next) {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== index; });
    const count = carousel.querySelector('[data-lfh-count]');
    if (count) count.textContent = `${index + 1} / ${slides.length}`;
  }
  function start() {
    clearInterval(timer);
    carousel.dataset.lfhMotionPaused = String(stopped || document.hidden);
    if (!stopped && !document.hidden && !carousel.matches(':hover, :focus-within')) timer = setInterval(() => show(index + 1), 6500);
  }
  function updatePause() {
    if (pause) {
      pause.setAttribute('aria-pressed', String(stopped));
      pause.setAttribute('aria-label', stopped ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      pause.textContent = stopped ? '▷' : 'Ⅱ';
    }
    start();
  }
  carousel.querySelector('[data-lfh-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
  carousel.querySelector('[data-lfh-next]')?.addEventListener('click', () => { show(index + 1); start(); });
  pause?.addEventListener('click', () => { stopped = !stopped; updatePause(); });
  ['mouseenter', 'focusin'].forEach(event => carousel.addEventListener(event, () => clearInterval(timer)));
  ['mouseleave', 'focusout'].forEach(event => carousel.addEventListener(event, start));
  document.addEventListener('visibilitychange', start);
  reduced.addEventListener('change', () => { stopped = reduced.matches; updatePause(); });
  updatePause();
});

const rideRate = document.querySelector('[data-lfr-rate]');
if (rideRate) {
  const prices = [...document.querySelectorAll('[data-lfr-cost]')];
  const euro = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' });
  rideRate.addEventListener('input', () => {
    const rate = rideRate.valueAsNumber;
    const valid = Number.isFinite(rate) && rate >= 0 && rate <= 5;
    rideRate.setAttribute('aria-invalid', String(!valid));
    prices.forEach(output => { output.textContent = valid ? euro.format(Number(output.dataset.lfrCost) / 1000 * rate * 1.15) : '—'; });
  });
}

const rideHeadline = document.querySelector('[data-lfh-typewriter]');
if (rideHeadline && typeof Element.prototype.animate === 'function') {
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const lines = [...rideHeadline.querySelectorAll('[data-lfh-type-line]')];
  rideHeadline.setAttribute('aria-label', lines.map(line => line.textContent.trim()).join(' '));
  const characters = [];
  lines.forEach((line, lineIndex) => {
    line.setAttribute('aria-hidden', 'true');
    const walker = document.createTreeWalker(line, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(node => {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(word => {
        if (!word.trim()) { fragment.append(document.createTextNode(word)); return; }
        const wordSpan = document.createElement('span');
        wordSpan.className = 'lfh-type-word';
        Array.from(word).forEach(letter => {
          const span = document.createElement('span');
          span.className = 'lfh-type-char';
          span.textContent = letter;
          wordSpan.append(span);
          characters.push({ span, lineIndex });
        });
        fragment.append(wordSpan);
      });
      node.replaceWith(fragment);
    });
  });
  const strokes = [...rideHeadline.querySelectorAll('.lfh-pen-stroke path')];
  let animations = [];
  let inView = true;
  function syncPlayback() {
    animations.forEach(animation => {
      if (inView && !document.hidden) animation.play();
      else animation.pause();
    });
  }
  function buildHeadlineAnimation() {
    animations.forEach(animation => animation.cancel());
    animations = [];
    if (motionPreference.matches) return;
    const startDelay = 350;
    const letterDelay = 85;
    const linePause = 180;
    const typingEnd = startDelay + (characters.length - 1) * letterDelay + linePause;
    const penStart = typingEnd + 300;
    const penEnd = penStart + 1800;
    const holdEnd = penEnd + 3400;
    const fadeEnd = holdEnd + 350;
    const duration = fadeEnd + 1050;
    const timing = { duration, iterations: Infinity, easing: 'linear' };
    const startTime = document.timeline.currentTime;
    characters.forEach(({ span, lineIndex }, index) => {
      const reveal = (startDelay + index * letterDelay + lineIndex * linePause) / duration;
      const animation = span.animate([
        { opacity: 0, offset: 0 },
        { opacity: 0, offset: reveal },
        { opacity: 1, offset: reveal + 0.0001 },
        { opacity: 1, offset: holdEnd / duration },
        { opacity: 0, offset: fadeEnd / duration },
        { opacity: 0, offset: 1 }
      ], timing);
      animation.startTime = startTime;
      animations.push(animation);
    });
    strokes.forEach((stroke, index) => {
      const begin = index ? penStart + 950 : penStart;
      const end = index ? penEnd + 350 : penEnd;
      const animation = stroke.animate([
        { strokeDashoffset: 1, opacity: 0, offset: 0 },
        { strokeDashoffset: 1, opacity: 0, offset: begin / duration },
        { strokeDashoffset: 1, opacity: 1, offset: (begin + 1) / duration },
        { strokeDashoffset: 0, opacity: 1, offset: end / duration },
        { strokeDashoffset: 0, opacity: 1, offset: holdEnd / duration },
        { strokeDashoffset: 0, opacity: 0, offset: fadeEnd / duration },
        { strokeDashoffset: 1, opacity: 0, offset: 1 }
      ], timing);
      stroke.style.strokeDasharray = '1';
      animation.startTime = startTime;
      animations.push(animation);
    });
    syncPlayback();
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      syncPlayback();
    }).observe(rideHeadline);
  }
  document.addEventListener('visibilitychange', syncPlayback);
  motionPreference.addEventListener('change', buildHeadlineAnimation);
  buildHeadlineAnimation();
}

// Keep a complete accessible link name while its visual letters type in place.
const guidedHelp = document.querySelector('[data-lfh-help-typewriter]');
if (guidedHelp) {
  let lastScroll = window.scrollY;
  let scrollFrame = false;
  let hideTimer;
  function tuckGuidedHelp() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      if (!guidedHelp.matches(':hover, :focus-within') && guidedHelp.getAttribute('aria-expanded') !== 'true') {
        guidedHelp.dataset.scrollVisible = 'false';
      }
    }, 2400);
  }
  window.addEventListener('scroll', () => {
    if (scrollFrame) return;
    scrollFrame = true;
    requestAnimationFrame(() => {
      const position = window.scrollY;
      if (Math.abs(position - lastScroll) >= 6) {
        guidedHelp.dataset.scrollVisible = 'true';
        lastScroll = position;
        tuckGuidedHelp();
      }
      scrollFrame = false;
    });
  }, { passive: true });
  ['mouseenter', 'focusin'].forEach(event => guidedHelp.addEventListener(event, () => clearTimeout(hideTimer)));
  ['mouseleave', 'focusout'].forEach(event => guidedHelp.addEventListener(event, tuckGuidedHelp));
}
if (guidedHelp && typeof Element.prototype.animate === 'function') {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const lines = [...guidedHelp.querySelectorAll('[data-lfh-help-line]')];
  guidedHelp.setAttribute('aria-label', lines.map(line => line.textContent.trim()).join(' ') + ' - ' + guidedHelp.querySelector('.lfh-help-assist').textContent.trim());
  const letters = [];
  lines.forEach((line, lineIndex) => {
    line.setAttribute('aria-hidden', 'true');
    const text = line.textContent;
    line.textContent = '';
    Array.from(text).forEach(letter => {
      const span = document.createElement('span');
      span.className = 'lfh-help-char';
      span.textContent = letter;
      line.append(span);
      if (letter.trim()) letters.push({ span, lineIndex });
    });
  });
  let animations = [];
  let inView = true;
  const border = guidedHelp.querySelector('.lfh-help-border rect');
  function syncGuidedMotion() {
    const running = inView && !document.hidden;
    animations.forEach(animation => running ? animation.play() : animation.pause());
    if (border) border.style.animationPlayState = running ? 'running' : 'paused';
  }
  function buildGuidedMotion() {
    animations.forEach(animation => animation.cancel());
    animations = [];
    if (preference.matches) return;
    const duration = 7600;
    const startTime = document.timeline.currentTime;
    letters.forEach(({ span, lineIndex }, index) => {
      const reveal = (200 + index * 85 + lineIndex * 100) / duration;
      const animation = span.animate([
        { opacity: 0, color: '#ffffff', offset: 0 },
        { opacity: 0, color: '#ffffff', offset: reveal },
        { opacity: 1, color: '#ffffff', offset: reveal + .0001 },
        { opacity: 1, color: '#ffffff', offset: .42 },
        { opacity: 0, color: '#ffffff', offset: .47 },
        { opacity: 0, color: '#ffd400', offset: .5 + reveal },
        { opacity: 1, color: '#ffd400', offset: .5 + reveal + .0001 },
        { opacity: 1, color: '#ffd400', offset: .92 },
        { opacity: 0, color: '#ffd400', offset: .97 },
        { opacity: 0, color: '#ffd400', offset: 1 }
      ], { duration, iterations: Infinity, easing: 'linear' });
      animation.startTime = startTime;
      animations.push(animation);
    });
    const arrow = guidedHelp.querySelector('b');
    if (arrow) {
      const mobileArrow = window.matchMedia('(max-width: 767px)').matches;
      const elastic = arrow.animate(mobileArrow ? [
        { transform: 'translate(0, 0)' },
        { transform: 'translate(2px, -2px)' },
        { transform: 'translate(0, 0)' }
      ] : [
        { transform: 'translate(0, 0) scale(1, 1)', offset: 0 },
        { transform: 'translate(0, 0) scale(1, 1)', offset: .3 },
        { transform: 'translate(7px, -4px) scale(1.55, .8)', offset: .36 },
        { transform: 'translate(-2px, 1px) scale(.88, 1.12)', offset: .4 },
        { transform: 'translate(2px, -1px) scale(1.08, .96)', offset: .44 },
        { transform: 'translate(0, 0) scale(1, 1)', offset: .48 },
        { transform: 'translate(0, 0) scale(1, 1)', offset: .8 },
        { transform: 'translate(7px, -4px) scale(1.55, .8)', offset: .86 },
        { transform: 'translate(-2px, 1px) scale(.88, 1.12)', offset: .9 },
        { transform: 'translate(2px, -1px) scale(1.08, .96)', offset: .94 },
        { transform: 'translate(0, 0) scale(1, 1)', offset: 1 }
      ], { duration, iterations: Infinity, easing: 'ease-in-out' });
      elastic.startTime = startTime;
      animations.push(elastic);
    }
    syncGuidedMotion();
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      syncGuidedMotion();
    }).observe(guidedHelp);
  }
  document.addEventListener('visibilitychange', syncGuidedMotion);
  preference.addEventListener('change', buildGuidedMotion);
  buildGuidedMotion();
}

const irelandScenes = document.querySelector('[data-lfh-scenes]');
if (irelandScenes) {
  const hero = irelandScenes.closest('.lfh-intro');
  const slides = [...irelandScenes.querySelectorAll('[data-lfh-scene]')];
  const controls = hero.querySelector('[data-lfh-scene-controls]');
  const pause = controls?.querySelector('[data-lfh-scene-pause]');
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let current = 0;
  let stopped = preference.matches;
  let inView = true;
  let changing = false;
  let timer;
  let preload;
  function loadScene(index) {
    const img = slides[index].querySelector('img');
    if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
    if (img.complete && img.naturalWidth) return Promise.resolve(true);
    return new Promise(resolve => {
      img.addEventListener('load', () => resolve(true), { once: true });
      img.addEventListener('error', () => resolve(false), { once: true });
    });
  }
  function scheduleScene() {
    clearTimeout(timer);
    clearTimeout(preload);
    if (stopped || document.hidden || !inView || hero.matches(':hover, :focus-within')) return;
    preload = setTimeout(() => { loadScene((current + 1) % slides.length); }, 2800);
    timer = setTimeout(() => { showScene(current + 1); }, 8500);
  }
  async function showScene(next) {
    if (changing) return;
    changing = true;
    const index = (next + slides.length) % slides.length;
    const loaded = await loadScene(index);
    if (loaded) {
      slides.forEach((slide, i) => {
        slide.dataset.active = String(i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.inert = i !== index;
      });
      current = index;

    }
    changing = false;
    scheduleScene();
  }
  function updateScenePause() {
    if (pause) {
    pause?.setAttribute('aria-pressed', String(stopped));
    pause?.setAttribute('aria-label', stopped ? pause.dataset.playLabel : pause.dataset.pauseLabel);
    if (pause) pause.textContent = stopped ? '▷' : 'Ⅱ';
    }
    scheduleScene();
  }
  controls?.querySelector('[data-lfh-scene-prev]')?.addEventListener('click', () => { showScene(current - 1); });
  controls?.querySelector('[data-lfh-scene-next]')?.addEventListener('click', () => { showScene(current + 1); });
  pause?.addEventListener('click', () => { stopped = !stopped; updateScenePause(); });
  ['mouseenter', 'focusin'].forEach(event => hero.addEventListener(event, () => { clearTimeout(timer); clearTimeout(preload); }));
  ['mouseleave', 'focusout'].forEach(event => hero.addEventListener(event, scheduleScene));
  document.addEventListener('visibilitychange', scheduleScene);
  preference.addEventListener('change', () => { stopped = preference.matches; updateScenePause(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => { inView = entries[0].isIntersecting; scheduleScene(); }).observe(hero);
  }
  const requestedScene = Number(new URLSearchParams(window.location.search).get('hero_scene'));
  if (requestedScene >= 1 && requestedScene <= slides.length) {
    showScene(requestedScene - 1);
  }
  updateScenePause();
}

